import { Link } from "react-router-dom";

export default function Home() {
  const videoLinkNext = encodeURIComponent("/admin?app=videolink");
  const avatarNext = encodeURIComponent("/admin?app=avatar");

  return (
    <div className="min-h-screen bg-ivory text-charcoal">
      <div className="max-w-4xl mx-auto px-6 py-16 md:py-24">
        <p className="font-mono text-[10.5px] uppercase tracking-wide text-concrete">
          videolink
        </p>
        <h1 className="mt-2 text-4xl md:text-5xl font-semibold tracking-tight-grot leading-[1.05]">
          Message vidéo, simplement.
        </h1>
        <p className="mt-5 text-concrete max-w-xl text-base leading-relaxed">
          Enregistre ou fais enregistrer un message via un lien personnel — ou prépare un{" "}
          <strong className="text-charcoal font-medium">avatar animé</strong> (personnage, fond,
          voix, langues), puis enregistre le mouvement et lance la génération (Kling → TTS →
          lip-sync).
        </p>

        <div className="mt-12 grid gap-4 md:grid-cols-2">
          <Link
            to={`/admin/login?next=${videoLinkNext}`}
            className="group rounded-xl border border-stone bg-paper p-6 shadow-sm transition hover:border-charcoal/40 hover:shadow-md"
          >
            <div className="font-mono text-[10px] uppercase text-concrete">01</div>
            <h2 className="mt-2 text-xl font-semibold tracking-tight group-hover:text-charcoal">
              VideoLink admin
            </h2>
            <p className="mt-2 text-sm text-concrete leading-relaxed">
              Liens d’invitation, vidéos reçues, création de nouveaux liens.
            </p>
            <span className="mt-4 inline-block text-sm font-medium text-charcoal underline-offset-4 group-hover:underline">
              Connexion →
            </span>
          </Link>

          <Link
            to={`/admin/login?next=${avatarNext}`}
            className="group rounded-xl border border-stone bg-charcoal p-6 text-ivory shadow-sm transition hover:opacity-[0.97]"
          >
            <div className="font-mono text-[10px] uppercase text-ivory/70">02</div>
            <h2 className="mt-2 text-xl font-semibold tracking-tight">Créateur d’avatar</h2>
            <p className="mt-2 text-sm text-ivory/85 leading-relaxed">
              Personnage, fond, voix, langues (multi-sélection), script — puis lien
              d’enregistrement et pipeline.
            </p>
            <span className="mt-4 inline-block text-sm font-medium text-lemon underline-offset-4 group-hover:underline">
              Connexion →
            </span>
          </Link>
        </div>

        <p className="mt-12 text-xs text-concrete font-mono">
          Accès réservé — identifiants admin (Supabase).
        </p>
      </div>
    </div>
  );
}
